export default function scrollToElement(elementId) {
  const headerHeight = document.querySelector('header').scrollHeight;
  const offset = document.getElementById(elementId).offsetTop;
  window.scrollTo({
    top: offset - headerHeight,
    behavior: 'smooth',
  });
}
